import { AxiosInstance } from 'axios';
import { BaseRequestEndpoints } from '@trukt/types/BaseRequestEndpoints';
import { fromArrayToCSV } from '@trukt/utils/fromArrayToCSV';
import {
  JobContractSearchRequest,
  JobContractSearchResponse,
  JobContractAcceptRequest,
  JobContractSendRequest,
  JobContractSendResponse,
  JobContractCancelRequest,
  JobContractCancelResponse,
} from './JobContractService.types';

export class JobContractService implements Pick<BaseRequestEndpoints, 'search'> {
  instance: AxiosInstance;
  constructor(instance: AxiosInstance) {
    this.instance = instance;
  }

  search(request: JobContractSearchRequest) {
    const { jobId } = request.routeParams;

    return this.instance.get<JobContractSearchResponse>(`jobs/${jobId}/contracts`, {
      params: {
        ...request.queryParams,
        status: fromArrayToCSV(request.queryParams.status),
      },
    });
  }

  accept(request: JobContractAcceptRequest) {
    const { contractId } = request.routeParams;

    return this.instance.put<JobContractSearchResponse>(`job-contracts/${contractId}/accept`);
  }

  decline(request: JobContractAcceptRequest) {
    const { contractId } = request.routeParams;

    return this.instance.put<JobContractSearchResponse>(`job-contracts/${contractId}/decline`);
  }

  cancel(request: JobContractCancelRequest) {
    const { contractId } = request.routeParams;

    return this.instance.put<JobContractCancelResponse>(`job-contracts/${contractId}/cancel`);
  }

  send(request: JobContractSendRequest) {
    return this.instance.post<JobContractSendResponse>('job-contracts', request.body);
  }
}
